import React from 'react';
import { Helmet } from 'react-helmet';
import { Layout } from 'antd';
import Banner from '../Banner';
import Resources from '../Resources';
import ContactUs from '../Contact';

export default function Home() {
  return (
    <Layout>
      <Helmet titleTemplate="%s - hD-TransforMAX " defaultTitle="hD-TransforMAX ">
        <meta name="description" content="hD-TransforMAX " />
      </Helmet>
      <Layout>
        <Layout>
          <Banner />
        </Layout>
        <Resources />
        <ContactUs />
      </Layout>
    </Layout>
  );
}
